<template>
  <div class="remark">
    <div class="title">
      其他说明&nbsp;
      <el-button
        v-show="!visible"
        type="primary"
        size="mini"
        plain
        style="margin-left: 50px"
        :disabled="!canEdit"
        :title="canEdit ? '' : '请取消投递后再更改简历'"
        @click="editFunc"
        >编辑</el-button
      >
    </div>
    <div v-if="!modelValue.remark && !visible" class="desc">如有其他情况，请说明一下</div>
    <div v-show="!visible" class="remark_content">{{ modelValue.remark }}</div>
    <div v-if="visible" class="form">
      <el-input
        v-model="remark"
        placeholder="请填写其他情况说明，不超过500字"
        clearable
        :rows="6"
        :maxlength="250"
        show-word-limit
        resize="none"
        type="textarea"
        style="width: 90%"
      />
      <div class="actions">
        <el-button type="primary" @click="onSubmit">保存</el-button>
        <el-button @click="onReset">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, watch, toRefs } from 'vue';
import { ElMessage } from 'element-plus';
import { useStore } from 'vuex';
import ApplicantApi from '../../service/api/applicant';
import { BASIC } from '../../utils/resume';

export default {
  name: 'Remark',
  components: {},
  props: {
    modelValue: {
      type: Object,
      default: () => ({}),
    },
    canEdit: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['callback', 'update:modelValue'],
  setup(props, context) {
    const state = reactive({
      visible: false,
      remark: '',
    });
    watch(
      () => props.modelValue,
      (value) => {
        state.remark = value.remark;
      },
    );

    const editFunc = () => {
      if (!props.modelValue.id) {
        return ElMessage.warning('请先填写基本信息');
      }
      state.remark = props.modelValue.remark || '';
      state.visible = true;
    };

    const store = useStore();
    const onSubmit = async () => {
      if (!state.remark) return ElMessage.warning('输入不能为空');
      const userInfo = store.state.userInfo;
      const formData = {
        remark: state.remark,
        id: props.modelValue.id,
        userId: userInfo.userId,
      };
      try {
        await ApplicantApi.updateResumeSelective(formData);
        context.emit('callback');
        ElMessage.success('保存成功');
        state.visible = false;
      } catch (e) {
        console.error('更新remark失败', e);
      }
    };
    const onReset = () => {
      state.remark = '';
      state.visible = false;
    };
    return {
      ...toRefs(state),
      editFunc,
      onSubmit,
      onReset,
      BASIC,
    };
  },
};
</script>

<style scoped lang="scss">
.remark {
  padding-bottom: 30px;
}
.title {
  color: #000;
  font-size: 20px;
  padding: 30px 20px;
  font-weight: 600;
  position: relative;
  &::before {
    content: '';
    position: absolute;
    width: 4px;
    height: 18px;
    background: #409eff;
    left: 8px;
    top: 36px;
  }
}
.desc {
  padding: 0 30px;
  font-size: 14px;
  color: #606266;
}
.remark_content {
  padding: 0 30px;
}
.form {
  padding: 0 30px;
  .actions {
    text-align: center;
    margin: 30px 0;
  }
}
</style>
